import { takeLatest, put, call } from 'redux-saga/effects';
import { initialize, reset } from 'redux-form';
import { browserHistory } from 'react-router';

import * as act from '../../actions';
import * as actNotif from '../../actions/notifications';
import {
  CONFIRM_EMPLOYEE_PAGE_REQUEST,
  CONFIRM_EMPLOYEE_CREATE_EMPLOYEE_ACCOUNT,
} from '../../actions/confirmEmployee/constants';
import {
  setInvitedEmployee,
  isInvalidInvitation,
} from '../../actions/confirmEmployee';

import { getEmployee } from '../../api/get-employee';
import { confirmEmployeeInvitation } from '../../api/confirm-employee';
import { assertErrorHasMessage } from '../../utils/assert';

function* fillFormConfirmEmployee(request) {
  const employee = request;
  const form = {
    firstName: employee.first_name,
    lastName: employee.last_name,
    email: employee.email,
    password: '',
    confirmPassword: '',
  };
  yield put(initialize('confirmEmployeeForm', form));
}

export function* pageRequest(request) {
  try {
    yield put(act.showProgressBar());
    const {
      payload: { params },
    } = request;
    const resEmployee = yield call(getEmployee, params);
    const employee = resEmployee.data.user;
    const { business } = resEmployee.data;

    yield call(fillFormConfirmEmployee, employee);
    yield put(setInvitedEmployee({ business, employee }));
  } catch (error) {
    assertErrorHasMessage(error);
    yield put(isInvalidInvitation(true));
    yield put(actNotif.error(error.message));
  } finally {
    yield put(act.hideProgressBar());
  }
}

export function* createEmployeeAccount(request) {
  try {
    yield put(act.showProgressBar());
    const {
      payload: {
        data: { business, employee },
      },
    } = request;
    yield call(confirmEmployeeInvitation, {
      business,
      employee,
    });
    browserHistory.push('/success-confirm-employee-invitation');
    yield put(actNotif.success('Employee invitation confirmed'));
  } catch (error) {
    assertErrorHasMessage(error);
    yield put(actNotif.error(error.message));
  } finally {
    yield put(reset('confirmEmployeeForm'));
    yield put(act.hideProgressBar());
  }
}

export default function* confirmEmployeeSaga() {
  yield takeLatest(CONFIRM_EMPLOYEE_PAGE_REQUEST, pageRequest);
  yield takeLatest(
    CONFIRM_EMPLOYEE_CREATE_EMPLOYEE_ACCOUNT,
    createEmployeeAccount
  );
}
